// ---------------------------------------------------------------------------
// Prezio Onboard Widget — SkeletonLoader
// ---------------------------------------------------------------------------
// Animated shimmer placeholders shown while step options are loading.
// Variants: 'card' (option lists), 'form' (input steps), 'summary'.
// ---------------------------------------------------------------------------

import styles from './SkeletonLoader.module.css';

interface SkeletonLoaderProps {
  variant?: 'card' | 'form' | 'summary';
}

export function SkeletonLoader({ variant = 'card' }: SkeletonLoaderProps) {
  return (
    <div className={styles['skeleton']} aria-busy="true" aria-label="Loading">
      {variant === 'card' && <CardSkeleton />}
      {variant === 'form' && <FormSkeleton />}
      {variant === 'summary' && <SummarySkeleton />}
    </div>
  );
}

function CardSkeleton() {
  return (
    <>
      <div className={styles['cardBone']} />
      <div className={styles['cardBone']} />
      <div className={styles['cardBone']} />
    </>
  );
}

function FormSkeleton() {
  return (
    <>
      <div className={styles['formLabel']} />
      <div className={styles['formInput']} />
      <div className={styles['formLabelWide']} />
      <div className={styles['formInput']} />
    </>
  );
}

function SummarySkeleton() {
  return (
    <>
      <div className={styles['summaryHeading']} />
      <div className={styles['summaryRow']} />
      <div className={styles['summaryRowShort']} />
      <div className={styles['summaryRow']} />
      <div className={styles['summaryRowShort']} />
    </>
  );
}
